import React from 'react';
import PropTypes from 'prop-types';

import {Pill} from 'views/components';
import {translate} from 'views/module';

const ClientStatusView = (props) => {
  const {
    clientData,
    setIsEditing,
  } = props;

  const status = clientData.status;

  const title = translate(`client.Status.${status}.Title`);

  return (
    <Pill
      label={`● ${title}`}
      variant='warning'
      component='button'
      type='button'
      onClick={() => setIsEditing(true)}
      sx={{cursor: 'pointer'}}
    />
  );
};

ClientStatusView.propTypes = {
  clientData: PropTypes.object.isRequired,
  setIsEditing: PropTypes.func.isRequired,
};

export default React.memo(ClientStatusView);
